import { Theme, withStyles } from 'beam/dist/styles'
import { Typography } from 'beam/dist/Typography'
import { TFunction, withTranslation } from 'react-i18next'
import { compose } from 'redux'
import { CustomTenantTheme } from '../app.api'

const styles = (theme: Theme & { palette: { navigationTextColor: string } }) => ({
  anchor: {
    textDecoration: 'none',
    opacity: 0.7,
    '& span': {
      color: theme.palette.navigationTextColor,
      fontSize: 14,
      textTransform: 'none',
    },
  },
})

interface Props {
  classes: { anchor: string },
  tenantId: number | null,
  theme: CustomTenantTheme | null,
  helpId: number | null,
  helpPage: string | null,
  languageId: string,
  t: TFunction,
  userType: string,
}

const addTrailingSlash = (url: string): string => {
  return url.endsWith('/') ? url : url + '/'
}

const helpNavigation = (tenantId: number | null, theme: CustomTenantTheme | null, helpId: number | null, helpPage: string | null, languageId: string, userType: string): string => {
  if (tenantId === -1) {
    // This is for system administrators to view the help center.
    return `/help/calabrio/${userType}/${languageId}/help.htm${helpId ? `?cshid=${helpId}` : ''}`
  }

  const baseHelpUrl = theme ? addTrailingSlash(theme.helpUrl) : 'https://help.calabrio.com/'

  return `${baseHelpUrl}doc/${helpPage ? `Content/user-guides/${helpPage}.htm` : 'container-home.htm'}`
}

const HelpLink: React.FC<Props> = ({ tenantId, theme, classes, helpId = null, helpPage = null, languageId = 'en', t, userType = 'user' }) => {
  const helpLinkRoute = helpNavigation(tenantId, theme, helpId, helpPage, languageId, userType)

  return (
    <a
      className={classes.anchor}
      target="_blank"
      rel="noopener noreferrer"
      href={helpLinkRoute}
      data-testid={'NavBar-helpLink'}
    >
      <Typography variant="button">{t('help')}</Typography>
    </a>
  )
}

export default compose(withTranslation(), withStyles(styles))(HelpLink)
